module.exports = __webpack_public_path__ + "img/h3xlogo.bd225c7d.svg";